import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from '../../Category/ProductItem';
import Pagination from '../../../hocs/Pagination/Pagination';
import { unique, flatten, shuffle } from '../../../utils/array';
import s from './Products.scss';

const Products = ({ setup, productCache, content = {}, attrs = {}, depth = false, seed = false }) => {
	if (!productCache || !productCache[setup.market] || !productCache[setup.market][setup.pricelist] || !content) return null;

	let completeProductList = [];
	const cache = productCache[setup.market][setup.pricelist];
	const classes = [s.products];

	if (attrs.align === 'full') classes[classes.length] = s.products__alignFull;
	if (depth === 1 && attrs.align !== 'full') classes[classes.length] = s.products__top;

	if (content.individual) {
		completeProductList = [...completeProductList, ...content.individual];
	} else if (content.category) {
		content.category.forEach((category) => {
			// Uses default en
			completeProductList = [...completeProductList, ...(cache.filterArrays.categoryVariants[category.default] ? cache.filterArrays.categoryVariants[category.default] : [])];
		});
	} else if (content.campaign) {
		content.campaign.forEach((campaign) => {
			completeProductList = [...completeProductList, ...(cache.filterArrays.campaigns[campaign.value] || [])];
		});
	} else if (content.brand) {
		content.brand.forEach((brand) => {
			completeProductList = [...completeProductList, ...cache.filterArrays.brands[brand.value]];
		});
	}

	completeProductList = completeProductList.map((id) => Object.keys(cache.products).filter((cacheID) => cacheID.indexOf(id) !== -1));
	completeProductList = flatten(completeProductList);
	completeProductList = unique(completeProductList);

	if (seed !== false) {
		completeProductList = shuffle(completeProductList, seed);
	}
	if (content.limit !== undefined) {
		completeProductList = completeProductList.slice(0, parseInt(content.limit, 10));
	}

	return (
		<div className={classes.join(' ')}>
			<Pagination variantClasses={[`productItem__perRow_${content.perRow}`]} ListComponent={ProductItem} list={completeProductList} cache={productCache[setup.market][setup.pricelist].products} currentPath="" canonical useFlatImages={content.variation === 'flat'} />
		</div>
	);
};

const mapState = ({ environment, pageStatus, productCache }, { content }) => ({
	setup: environment.setup,
	seed: pageStatus?.seed?.[0] || false,
	productCache,
	content,
});

export default hot(module)(connect(mapState)(Products));
